import Resource from './Resource'

class Wallet extends Resource {
  get id() {
    return this.data._id
  }

  get name() {
    return this.data.name
  }

  get balance() {
    return this.data.balance
  }

  get currency() {
    return this.data.currency
  }

  get address() {
    return this.data.address
  }

  get type() {
    return this.data.type
  }

  get verified() {
    return this.data.verified
  }
}

export default Wallet
